module.exports = __webpack_public_path__ + "img/level3addon_mining_tool_mask.40d41a24.png";